import {onUnmounted} from 'vue';
import {useAppContext} from '../../components/app/AppContext';
import {Role} from '../../records/user.record';
import {WootricService} from '../../services/common/wootric.service';
import {useService} from '../useService';

const DEFAULT_CREATED_AT = new Date('2026-01-01').getTime() / 1000;

function buildUserContext(): {
    email: string;
    customerName: string;
    userRole: string;
    createdAt?: number;
} | null {
    const {user} = useAppContext();
    if (!user?.email) {
        return null;
    }
    return {
        email: user.email,
        customerName: user.account.globalId + ' - ' + user.account.name,
        userRole: user.currentRole ?? Role.DISPATCHER,
        createdAt: user.account.createdAt ? Math.round(user.account.createdAt / 1000) : DEFAULT_CREATED_AT
    };
}

export function startWootric(): void {
    const context = buildUserContext();
    if (!context) {
        return;
    }
    void useService(WootricService).run(context);
}

export function useWootric(): void {
    onUnmounted(() => {
        useService(WootricService).stop();
    });
}
